import apiUtil from "@/util/apiUtil";
import {ISODateString} from "@/util/dateUtil";
import {
    IDriveThruReplayResponse,
    ICameraFeedResponse
} from "./driveThruReplayModels";

const driveThruReplayAPI = {
    async getDriveThruDayData(
        locationPk: number,
        date: ISODateString,
        signal?: AbortSignal
    ): Promise<IDriveThruReplayResponse | null> {
        const url = `/api/CoachInsights/DriveThruDayData/${locationPk}/${date}`;
        const response = await apiUtil.fetchData<IDriveThruReplayResponse>(
            url,
            signal
        );
        return typeof response === "object" && response !== null ? response : null;
    },

    async getCameraFeed(
        locationPk: number,
        businessDate: ISODateString,
        secondOfDay: number,
        totalSec: number | null,
        signal?: AbortSignal
    ): Promise<ICameraFeedResponse | null> {
        const totalSecParam =
            totalSec != null && totalSec > 0 ? `&totalSec=${totalSec}` : "";
        const url = `/api/CoachInsights/DriveThruReplay/${locationPk}/CameraFeed?businessDate=${businessDate}&secondOfDay=${secondOfDay}${totalSecParam}`;
        const response = await apiUtil.fetchData<ICameraFeedResponse>(url, signal);
        return typeof response === "object" && response !== null ? response : null;
    }
};

export default driveThruReplayAPI;
